module.exports = __webpack_public_path__ + "img/wei4.fc56e316.png";